"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartItemCount = void 0;
const pushToDataLayer_1 = require("../pushToDataLayer");
function trackCartItemCount(itemCount) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        cart_item_count: itemCount,
    });
}
exports.trackCartItemCount = trackCartItemCount;
//# sourceMappingURL=trackCartItemCount.js.map